import * as userResource from 'resources/user/hooks';

import * as userHelpers from 'resources/user/user.helpers';

const useCurrentCompanyInfo = () => {
  const { data: user } = userResource.useCurrentUser();
  const { data: teamMembers } = userResource.useTeamMembers(user?.company_id);
  const { data: companyClients } = userResource.useCompanyClients(user?.company_id, user?.id);

  const admins = teamMembers?.filter((member) => userHelpers.isCoordinatorOrAdmin(member));

  const adminsCount = admins?.length;
  const agentsCount = teamMembers?.filter((member) => userHelpers.isRealtor(member))?.length;
  const clientsCount = companyClients?.length;

  return {
    admins, adminsCount, agentsCount, clientsCount,
  };
};

export default useCurrentCompanyInfo;
